import { Link } from "react-router-dom/cjs/react-router-dom";
import MyCourse from "../MyCourse/MyCourse";
import FavouriteCourse from "../FavouriteCourse/FavouriteCourse";
import React from "react";
const LastCourse = (args) => {
    const lastCourse = args?.lastCourse
    return (
        <div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="custom-tab-1 latest-recruitment">
                                <strong className='upcome'>Last Course</strong>
                                <div className="tab-content">
                                    <div id="in-progress" className="tab-pane active">
                                        <Link to={`/SelfLearningDashboard/CourseDetails/${lastCourse?.Id}`}> <div className="courselist">
                                            <div className="mycourselist">
                                                <div className="imgdiv">
                                                    <img className="avatar is-squared w-100" src="images/org-img/learn/2.jpg" />
                                                    <span className="course-time"><img src="images/org-img/recruitment/time.svg" />2h 30m</span>
                                                </div>
                                                <div className="course-card">
                                                    <span className="leveltag">{lastCourse?.Name}</span>
                                                    <h3 className="dark-inverted">{lastCourse?.CourseTitle}</h3>
                                                    <p>Web Development</p>
                                                    <div className="students pb-0">
                                                        <div className="h-avatar is-small">
                                                            <img className="avatar" src="images/avatar/6.jpg" alt="" />
                                                        </div>
                                                        <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                                    </div>
                                                    <div className="attached-block">
                                                        <ul>
                                                            <li>66 Articles</li>
                                                            <li>6 Exercies</li>
                                                            <li>{lastCourse?.Quiz} Quizz</li>
                                                        </ul>
                                                    </div>
                                                    <div className="progress mt-3">
                                                        <div className="progress-bar" role="progressbar" style={{ width: " 25%" }}
                                                            aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div></Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12">
                    <MyCourse lastCourse={lastCourse}/>
                </div>
                <div className="col-xl-12">
                    <FavouriteCourse lastCourse={lastCourse} />
                </div>

            </div>
        </div>
    )
}
export default LastCourse;